import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.V6SsiProcessor.';
  public static readonly totalShippingCost = `${Id.prefix}totalShippingCost`;
  public static readonly shipping = `${Id.prefix}shipping`;
}

export class LangV6SsiProcessor {
  private constructor() {}
  public static totalShippingCost(): string {
    return interpolate(Id.totalShippingCost);
  }
  public static shipping(): string {
    return interpolate(Id.shipping);
  }
}

export class V6SsiProcessorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.totalShippingCost, 'Total Shipping Cost', 'Description for total shipping cost quote item');
    register.add(Id.shipping, 'Shipping', 'Title for shipping quote item');
  }
}
